import type { Metadata } from "next";
import AdminSettings from '@/Component/Admin/AdminSettings'

export const metadata: Metadata = {
    title: "Settings | Connector Club",
    description: "",
};

const AdminSettingsPage = () => {
  return (
    <AdminSettings />
  )
}

export default AdminSettingsPage
